import { RequestError } from '../../api/errors/request.error';

export const ACCOUNT_NOT_FOUND_MESSAGE = 'Er is geen Jobtracker-account gevonden voor dit Microsoft-account.';

export const getCurrentUserAuthErrorMessage = (error: unknown): string | null => {
  if (!(error instanceof RequestError)) {
    return null;
  }

  const { apiError } = error;
  if (apiError.error !== 'unauthorized') {
    return null;
  }

  return apiError.message === ACCOUNT_NOT_FOUND_MESSAGE ? apiError.message : null;
};

export const isCurrentUserSessionExpiredError = (error: unknown): boolean => {
  if (!(error instanceof RequestError)) {
    return false;
  }

  const { apiError } = error;
  return apiError.error === 'unauthorized' && apiError.message !== ACCOUNT_NOT_FOUND_MESSAGE;
};

export const shouldMarkCurrentUserSessionExpired = (
  error: unknown,
  hasCurrentUser: boolean,
  alreadySessionExpired: boolean,
): boolean => (
  (hasCurrentUser || alreadySessionExpired) && isCurrentUserSessionExpiredError(error)
);
